import $ from "jquery";
import ChangeEvent = JQuery.ChangeEvent;
import { showPageLoader, hidePageLoader } from "./page-loader";
import { manageModals } from "./modal";
import { ctaLoadingClass } from "./utils";

const dealerGridSelector = ".dealer-grid .dealer-list";
const dealerGridItemSelector = ".dealer-grid__item";
const contactDealerCTASelector = ".contact-dealer-cta";
const contactDealerModalSelector = "#catifa-contact-dealer-modal";
const modalDealerNameTitleSelector = "#dealer-name-title";
const modalDealerNameInputSelector = "#dealer-name";

const $dealerGrid = $(dealerGridSelector);
const $contactDealerModal = $(contactDealerModalSelector);
const $modalDealerNameTitle = $contactDealerModal.find(
  modalDealerNameTitleSelector,
);
const $modalDealerNameInput = $contactDealerModal.find(
  modalDealerNameInputSelector,
);
const dealerFilterSelector = "#dealer-country-filter";

// @ts-ignore Unused, first attempt to list dealers, we chose to filter them from the liquid template instead
const fetchDealers = async (localization: string) => {
  const dealerGridItemTemplateSelector = "#dealer-grid-item-template";

  const $dealerGridItemTemplate = $(dealerGridItemTemplateSelector);
  fetch("/apps/catifa-api/app/api", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      command: "get_filtered_dealer_list",
      payload: {
        localization: localization,
      },
    }),
  })
    .then((response) => {
      if (!response.ok) {
        const errorMessage = "Failed to get dealer list";
        throw new Error(errorMessage);
      }
      return response.json();
    })
    .then((response) => {
      // Prepare new grid items from response using $dealerGridItemTemplate
      const newItems: JQuery<HTMLElement>[] = [];
      for (const item of response.items) {
        const newItem = $dealerGridItemTemplate.clone();
        newItem
          .find(".dealer-grid__item__data_name")
          ?.data("dealerName", item.name);
        newItem.find(".dealer-grid__item__name")?.html(item.name);
        if (item.address) {
          newItem.find(".dealer-grid__item__address")?.html(item.address);
        } else {
          newItem.find(".dealer-grid__item__address_ctn").remove();
        }
        if (item.website_url) {
          newItem
            .find(".dealer-grid__item__website_url_cta")
            ?.attr("href", item.website_url);
          newItem
            .find(".dealer-grid__item__website_url")
            ?.html(item.website_url);
        } else {
          newItem.find(".dealer-grid__item__website_ctn").remove();
        }
        if (item.phone) {
          newItem
            .find(".dealer-grid__item__phone_cta")
            ?.attr("href", "tel:" + item.phone);
        } else {
          newItem.find(".dealer-grid__item__phone_cta").remove();
        }
        newItem.removeClass("hidden");
        newItems.push(newItem);
      }
      // clear grid items
      $dealerGrid.empty();
      // populate grid with new items
      $dealerGrid.append(newItems);
      // reset broken modals and cta listeners
      manageModals();
      manageDealersModalOpenerCTAs();
    })
    .catch((e: Error) => {
      // TODO: better handle error
      console.log(e.message);
    });
};

export const manageDealerModal = () => {
  manageDealersFilter();
  manageDealersModalOpenerCTAs();
  manageDealersModalSubmit();
};

export const manageDealersFilter = () => {
  const $dealerFilter = $(dealerFilterSelector);

  $dealerFilter.on("change", function (event: ChangeEvent) {
    showPageLoader();
    setTimeout(function () {
      const localization = event.target.value;
      const $itemsToHide = $(
        dealerGridItemSelector +
          ":not(" +
          dealerGridItemSelector +
          "-" +
          localization +
          ")",
      );
      $itemsToHide.addClass("hidden");
      const $itemsToShow = $(dealerGridItemSelector + "-" + localization);
      $itemsToShow.removeClass("hidden");
      hidePageLoader();
    }, 300);
  });
};
const contactDealerFormSelector = "#contact-dealer-form";
export const manageDealersModalOpenerCTAs = () => {
  const $contactDealerCTAs = $dealerGrid.find(contactDealerCTASelector);
  $contactDealerCTAs.on("click", function () {
    const dealerName = $(this).data("dealerName");
    $modalDealerNameTitle.html(dealerName);
    $modalDealerNameInput.val(dealerName);

    // ensure the form is visible
    $(contactDealerFormSelector).show();
    document
      .querySelector(contactDealerModalSelector)
      ?.querySelector(".catifa-form-success-message")
      ?.classList.add("hidden");
  });
};

export const manageDealersModalSubmit = () => {
  const $form = $(contactDealerFormSelector) as JQuery<HTMLFormElement>;

  if (!$form.length) {
    return;
  }

  // we're relying on the form not being submitted if not valid
  $form.on("submit", async function (event) {
    event.preventDefault();
    const formData = new FormData(this);
    const $submitButton = $form.find(
      "[type=submit]",
    ) as JQuery<HTMLButtonElement>;
    if ($submitButton.length && $submitButton[0]) {
      $submitButton[0].disabled = true;
      $submitButton[0].classList.add(ctaLoadingClass);
    }
    const formPayload: { [key in string]: string | File } = {};
    formData.forEach((value, key) => (formPayload[key] = value));
    window.dataLayer = window.dataLayer || [];
    const res = await fetch("/apps/catifa-api/app/api", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        command: "create_dealer_contact",
        payload: {
          ...formPayload,
          terms_and_conditions_acceptance: true,
          country:
            document.querySelector<HTMLSelectElement>("#locale_code")!.value,
        },
      }),
    });
    if ($submitButton.length && $submitButton[0]) {
      $submitButton[0].disabled = false;
      $submitButton[0].classList.remove(ctaLoadingClass);
    }
    if (!res.ok) {
      return res
        .json()
        .then((errorData) => {
          const errorMessage =
            errorData.message ||
            res.statusText ||
            "Failed to submit contact store form";
          if (window.dataLayer !== undefined) {
            window.dataLayer.push({
              event: "form_error",
              type: "dealer",
              message: errorMessage,
            });
          }
          throw new Error(errorMessage);
        })
        .finally(() => {
          document
            .querySelector(contactDealerModalSelector)
            ?.querySelector(".catifa-form-error-message")
            ?.classList.remove("hidden");
          return;
        });
    }

    if (window.dataLayer !== undefined) {
      window.dataLayer.push({
        event: "dealer_form_submit",
        email: formPayload.email ?? "email_missing",
        phone_number: formPayload.phone_number ?? "phone_number_missing",
        store_name: formPayload.dealer_name ?? "dealer_name_missing",
        marketing_consent: "true", // requested by the tracking company to pass it as a string
      });
    }

    this.reset();

    // try avoiding double submission
    $(this).hide();

    document
      .querySelector(contactDealerModalSelector)
      ?.querySelector(".catifa-form-success-message")
      ?.classList.remove("hidden");
  });
};
